import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { AuthForm } from '../../AuthForm';

import * as AUTH_SELECTORS from '../../../store/selectors/auth';

import { emptyFunc } from '../../../helpers/function/emptyFunc';

import { SIGN_IN_STEP } from '../../../const/user/SIGN_IN_STEP';
import { LOCALE_NAMESPACE } from '../../../const/translations/LOCALE_NAMESPACE';

import styles from './BuySubscriptionSignInDialog.module.scss';

const T_PREFIX = 'subscriptionsScreen.dialogs.buySignIn';
const T_HEADER = `${T_PREFIX}.header`;

const getDialogTitle = ({ step }) => {
    if ([SIGN_IN_STEP.LOGIN, SIGN_IN_STEP.VERIFY_PASSWORD].includes(step)) {
        return `${T_HEADER}.title.signIn`;
    }
    if ([SIGN_IN_STEP.VERIFY_EMAIL].includes(step)) {
        return `${T_HEADER}.title.enterCode`;
    }
    if ([SIGN_IN_STEP.FILL_PROFILE].includes(step)) {
        return `${T_HEADER}.title.signUp`;
    }
    return `${T_HEADER}.title.enterEmail`;
}

const BuySubscriptionSignInDialog = (props) => {
    const {
        isVisible,
        onClose,
    } = props;

    const { t } = useTranslation(LOCALE_NAMESPACE.COMMON);

    const { step } = useSelector(AUTH_SELECTORS.authSelector);

    return (
        <Modal
            show={isVisible}
            container={document.getElementById('root_appybee_widget')}
            onHide={onClose}
        >
            <Modal.Header>
                <h4 className={styles.dialogTitle} data-testid={`data-test-buySubscriptionSignInDialog-${step}-title`}>
                    {t(getDialogTitle({ step }))}
                </h4>
            </Modal.Header>
            <Modal.Body>
                <div className={styles.contentContainer}>
                    <AuthForm showFooter={false} />
                </div>
            </Modal.Body>
            <Modal.Footer className={styles.dialogFooter}>
                <AuthForm.Footer />
            </Modal.Footer>
        </Modal>
    );
};

BuySubscriptionSignInDialog.propTypes = {
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
};

BuySubscriptionSignInDialog.defaultProps = {
    isVisible: false,
    onClose: emptyFunc,
};

export default BuySubscriptionSignInDialog;
